export default "__VITE_ASSET__DGutqcyi__"